import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import icon1 from "../../images/shape/trangle-shape.png";
import icon2 from "../../images/icon/m_01.svg";
import icon5 from "../../images/icon/m_04.svg";
import icon11 from "../../images/icon/m_10.svg";
import icon12 from "../../images/icon/m_11.svg";
import logo from "../../images/logo/Logo-certa.png";
import quote from "../../images/icon/quote.png";
import MobileMenu from "../MobileMenu/MobileMenu";

const Header = (props) => {
  const [mobailActive, setMobailState] = useState(false);

  const ClickHandler = () => {
    window.scrollTo(10, 0);
  };

  const [isSticky, setSticky] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 80) {
        setSticky(true);
      } else {
        setSticky(false);
      }
    };

    window.addEventListener("scroll", handleScroll);

    // Clean up
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  const SubmitHandler = (e) => {
    e.preventDefault();
  };

  return (
    <div
      id="xb-header-area"
      className="header-area header-style-two header-transparent header2-black-text"
    >
      <div className="header-top">
        <span>
          Aproveite nossa oferta do mês! Cloud VPS com infraestrutura nacional.
        </span>
        <span>
          <Link onClick={ClickHandler} to="/pricing">
            Saiba mais
          </Link>
          <i className="far fa-angle-right"></i>
        </span>
        <div className="header-shape">
          <div className="shape shape--one">
            <img src={icon1} alt="" />
          </div>
          <div className="shape shape--two">
            <img src={icon1} alt="" />
          </div>
        </div>
      </div>
      <div
        className={`xb-header stricky  ${
          isSticky ? "stricked-menu stricky-fixed" : ""
        }`}
      >
        <div className="container">
          <div className="header__wrap ul_li_between d-flex align-items-center">
            <div className="header-logo">
              <Link onClick={ClickHandler} to="/">
                <img
                  src={logo}
                  alt="Somar Cloud Logo"
                  style={{
                    transition: "opacity 0.3s ease-in-out",
                    maxHeight: "40px",
                    width: "auto",
                  }}
                />
              </Link>
            </div>
            <div className="main-menu__wrap ul_li navbar navbar-expand-xl flex-grow-1 justify-content-center">
              <nav className="main-menu collapse navbar-collapse">
                <ul>
                  <li className="menu-item-has-children">
                    <Link onClick={ClickHandler} to="/">
                      <span>Home</span>
                    </Link>
                  </li>
                  <li className="menu-item-has-children megamenu">
                    <Link onClick={ClickHandler} to="/">
                      <span>Empresa</span>
                    </Link>
                    <ul className="submenu">
                      <li>
                        <div className="mega_menu_wrapper">
                          <div className="container">
                            <div className="mega_menu_wrapper_inner">
                              <div className="row align-items-center">
                                {/* Card Sobre Nós */}
                                <div className="col-xl-3 col-md-6 mb-3 mb-xl-0">
                                  <Link
                                    onClick={ClickHandler}
                                    className="iconbox_block_2"
                                    to="/about"
                                    style={{ height: "100%" }}
                                  >
                                    <span className="icon_title_wrap">
                                      <small className="iconbox_icon">
                                        <img src={icon2} alt="" />
                                      </small>
                                      <small className="iconbox_title">
                                        Sobre Nós
                                      </small>
                                    </span>
                                    <span className="description mb-0">
                                      Referência em Cloud Services
                                    </span>
                                  </Link>
                                </div>

                                {/* Card Soluções */}
                                <div className="col-xl-3 col-md-6 mb-3 mb-xl-0">
                                  <Link
                                    onClick={ClickHandler}
                                    className="iconbox_block_2"
                                    to="/service"
                                    style={{ height: "100%" }}
                                  >
                                    <span className="icon_title_wrap">
                                      <small className="iconbox_icon">
                                        <img src={icon5} alt="" />
                                      </small>
                                      <small className="iconbox_title">
                                        Soluções
                                      </small>
                                    </span>
                                    <span className="description mb-0">
                                      Potencialize seus Resultados
                                    </span>
                                  </Link>
                                </div>

                                {/* Badges/Diferenciais */}
                                <div className="col-xl-3 col-md-6 mb-3 mb-xl-0">
                                  <div
                                    className="megamenu_badges"
                                    style={{
                                      padding: "20px",
                                      background: "#f8f9fa",
                                      borderRadius: "10px",
                                      height: "100%",
                                    }}
                                  >
                                    <div style={{ marginBottom: "12px" }}>
                                      <div
                                        style={{
                                          fontSize: "11px",
                                          color: "#666",
                                          marginBottom: "5px",
                                          textTransform: "uppercase",
                                          letterSpacing: "1px",
                                          fontWeight: "600",
                                        }}
                                      >
                                        Nossos Diferenciais
                                      </div>
                                    </div>
                                    <div
                                      style={{
                                        display: "flex",
                                        flexDirection: "column",
                                        gap: "8px",
                                      }}
                                    >
                                      <div
                                        style={{
                                          display: "flex",
                                          alignItems: "center",
                                          gap: "8px",
                                        }}
                                      >
                                        <i
                                          className="fas fa-shield-alt"
                                          style={{
                                            color: "#0E55DC",
                                            fontSize: "14px",
                                            width: "16px",
                                          }}
                                        ></i>
                                        <span
                                          style={{
                                            fontSize: "13px",
                                            color: "#333",
                                          }}
                                        >
                                          Tier III Datacenter
                                        </span>
                                      </div>
                                      <div
                                        style={{
                                          display: "flex",
                                          alignItems: "center",
                                          gap: "8px",
                                        }}
                                      >
                                        <i
                                          className="fas fa-check-circle"
                                          style={{
                                            color: "#0E55DC",
                                            fontSize: "14px",
                                            width: "16px",
                                          }}
                                        ></i>
                                        <span
                                          style={{
                                            fontSize: "13px",
                                            color: "#333",
                                          }}
                                        >
                                          13+ Anos de experiência
                                        </span>
                                      </div>
                                      <div
                                        style={{
                                          display: "flex",
                                          alignItems: "center",
                                          gap: "8px",
                                        }}
                                      >
                                        <i
                                          className="fas fa-map-marker-alt"
                                          style={{
                                            color: "#0E55DC",
                                            fontSize: "14px",
                                            width: "16px",
                                          }}
                                        ></i>
                                        <span
                                          style={{
                                            fontSize: "13px",
                                            color: "#333",
                                          }}
                                        >
                                          Infraestrutura Nacional
                                        </span>
                                      </div>
                                      <div
                                        style={{
                                          display: "flex",
                                          alignItems: "center",
                                          gap: "8px",
                                        }}
                                      >
                                        <i
                                          className="fas fa-headset"
                                          style={{
                                            color: "#0E55DC",
                                            fontSize: "14px",
                                            width: "16px",
                                          }}
                                        ></i>
                                        <span
                                          style={{
                                            fontSize: "13px",
                                            color: "#333",
                                          }}
                                        >
                                          Suporte 24/7
                                        </span>
                                      </div>
                                    </div>
                                  </div>
                                </div>

                                {/* CTA Destaque */}
                                <div className="col-xl-3 col-md-6">
                                  <div
                                    className="megamenu_cta"
                                    style={{
                                      background:
                                        "linear-gradient(135deg, #0E55DC 0%, #0a3d9e 100%)",
                                      padding: "25px 20px",
                                      borderRadius: "10px",
                                      textAlign: "center",
                                      height: "100%",
                                      display: "flex",
                                      flexDirection: "column",
                                      justifyContent: "center",
                                      minHeight: "180px",
                                    }}
                                  >
                                    <h4
                                      style={{
                                        color: "white",
                                        fontSize: "15px",
                                        marginBottom: "8px",
                                        fontWeight: "600",
                                        lineHeight: "1.4",
                                      }}
                                    >
                                      Cloud VPS Nacional
                                    </h4>
                                    <p
                                      style={{
                                        color: "rgba(255,255,255,0.9)",
                                        fontSize: "12px",
                                        marginBottom: "15px",
                                        lineHeight: "1.5",
                                      }}
                                    >
                                      Performance superior, menor latência
                                    </p>
                                    <Link
                                      onClick={ClickHandler}
                                      to="/pricing"
                                      style={{
                                        background: "white",
                                        color: "#0E55DC",
                                        padding: "10px 20px",
                                        borderRadius: "5px",
                                        fontSize: "13px",
                                        fontWeight: "600",
                                        border: "none",
                                        display: "inline-block",
                                        textDecoration: "none",
                                        transition: "all 0.3s ease",
                                      }}
                                    >
                                      Ver Planos
                                    </Link>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </li>
                    </ul>
                  </li>
                  <li className="menu-item-has-children megamenu">
                    <Link onClick={ClickHandler} to="/service">
                      <span>Soluções</span>
                    </Link>
                    <ul className="submenu">
                      <li>
                        <div className="mega_menu_wrapper">
                          <div className="container">
                            <div className="mega_menu_wrapper_inner megamenu_widget_wrapper">
                              <div className="row justify-content-lg-between">
                                <div className="col-xl-8">
                                  <div className="megamenu_widget_inner">
                                    <div className="row">
                                      <div className="col-xl-6">
                                        <div className="megamenu_widget">
                                          <ul className="icon_list unordered_list_block">
                                            <li>
                                              <span className="icon_list_text fs-3 text-primary fw-bold">
                                                Nuvem:
                                              </span>
                                            </li>
                                            <li>
                                              <Link
                                                onClick={ClickHandler}
                                                to="/cloud-vps"
                                              >
                                                <span className="icon_list_text">
                                                  Cloud VPS
                                                </span>
                                              </Link>
                                            </li>
                                            <li>
                                              <Link
                                                onClick={ClickHandler}
                                                to="/cloud-server"
                                              >
                                                <span className="icon_list_text">
                                                  Cloud Server
                                                </span>
                                              </Link>
                                            </li>
                                            <li>
                                              <Link
                                                onClick={ClickHandler}
                                                to="/data-center-virtual"
                                              >
                                                <span className="icon_list_text">
                                                  Data Center Virtual
                                                </span>
                                              </Link>
                                            </li>
                                          </ul>
                                        </div>
                                      </div>
                                      <div className="col-xl-6">
                                        <div className="megamenu_widget">
                                          <ul className="icon_list unordered_list_block">
                                            <li>
                                              <span className="icon_list_text fs-3 text-primary fw-bold">
                                                Outras Soluções:
                                              </span>
                                            </li>
                                            <li>
                                              <Link
                                                onClick={ClickHandler}
                                                to="/vdi-windows11"
                                              >
                                                <span className="icon_list_text">
                                                  VDI Windows 11
                                                </span>
                                              </Link>
                                            </li>
                                            <li>
                                              <Link
                                                onClick={ClickHandler}
                                                to="/disaster-recorvery"
                                              >
                                                <span className="icon_list_text">
                                                  Disaster Recorvery
                                                </span>
                                              </Link>
                                            </li>
                                            <li>
                                              <Link
                                                onClick={ClickHandler}
                                                to="/microsoft-exchange"
                                              >
                                                <span className="icon_list_text">
                                                  Microsoft Exchange
                                                </span>
                                              </Link>
                                            </li>
                                            <li>
                                              <Link
                                                onClick={ClickHandler}
                                                to="/firewall-comodato"
                                              >
                                                <span className="icon_list_text">
                                                  Firewall Comodato
                                                </span>
                                              </Link>
                                            </li>
                                            <li>
                                              <Link
                                                onClick={ClickHandler}
                                                to="/backup-cloud"
                                              >
                                                <span className="icon_list_text">
                                                  Backup Cloud
                                                </span>
                                              </Link>
                                            </li>
                                            <li>
                                              <Link
                                                onClick={ClickHandler}
                                                to="/desenvolvimento-web"
                                              >
                                                <span className="icon_list_text">
                                                  Desenvolvimento Web
                                                </span>
                                              </Link>
                                            </li>
                                          </ul>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="social_area">
                                    <div className="social_inner ul_li">
                                      <h5>Nos acompanhe nas redes:</h5>
                                      <ul className="social_icons_block unordered_list">
                                        <li>
                                          <Link onClick={ClickHandler} to="/">
                                            <i className="fab fa-facebook-f"></i>
                                          </Link>
                                        </li>
                                        <li>
                                          <Link onClick={ClickHandler} to="/">
                                            <i className="fab fa-linkedin-in"></i>
                                          </Link>
                                        </li>
                                        <li>
                                          <Link onClick={ClickHandler} to="/">
                                            <i className="fab fa-youtube text-danger"></i>
                                          </Link>
                                        </li>
                                      </ul>
                                    </div>
                                    {/* <p className="career_link m-0">
                                      Gostaria de trabalhar conosco?{" "}
                                      <Link onClick={ClickHandler} to="/career">
                                        Estamos contratando
                                      </Link>
                                    </p> */}
                                  </div>
                                </div>
                                <div className="col-xl-4">
                                  <div className="autpr_box d-flex align-items-center justify-content-center h-100 m-auto">
                                    <div className="site_author text-left">
                                      <div className="author_box">
                                        <div className="author_box_content">
                                          <h2 className="author_name text-white">
                                            Reduza custos e melhore a
                                            performance da sua operação.
                                          </h2>
                                          <span className="author_designation text-white">
                                            Cloud VPS com infraestrutura
                                            nacional.
                                          </span>
                                        </div>
                                      </div>
                                      <p className="mb-0 text-white"> </p>
                                      <Link
                                        onClick={ClickHandler}
                                        to="/pricing"
                                        className="thm-btn thm-btn--aso megamenu-btn thm-btn--header-blue"
                                      >
                                        Quero Conhecer!
                                      </Link>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </li>
                    </ul>
                  </li>
                  {/* <li className="menu-item-has-children">
                    <Link onClick={ClickHandler} to="/projects">
                      <span>Projetos Entregues</span>
                    </Link>
                  </li> */}
                  {/* <li className="menu-item-has-children">
                    <Link onClick={ClickHandler} to="/blog">
                      <span>Blog</span>
                    </Link>
                  </li> */}
                  <li>
                    <Link onClick={ClickHandler} to="/contact">
                      <span>Contato</span>
                    </Link>
                  </li>
                </ul>
              </nav>
              <div className="xb-header-wrap">
                <div
                  className={`xb-header-menu ${mobailActive ? "active" : ""}`}
                >
                  <div className="xb-header-menu-scroll lenis lenis-smooth">
                    <div
                      className="xb-menu-close xb-hide-xl xb-close"
                      onClick={() => setMobailState(!mobailActive)}
                    ></div>
                    <div className="xb-logo-mobile xb-hide-xl">
                      <Link onClick={ClickHandler} to="/" rel="home">
                        <img src={logo} alt="" />
                      </Link>
                    </div>
                    <div className="xb-header-mobile-search xb-hide-xl">
                      <form role="search" onSubmit={SubmitHandler}>
                        <input
                          type="text"
                          placeholder="Search..."
                          name="s"
                          className="search-field"
                        />
                        <button className="search-submit" type="submit">
                          <i className="far fa-search"></i>
                        </button>
                      </form>
                    </div>
                    <nav className="xb-header-nav">
                      <MobileMenu />
                    </nav>
                  </div>
                </div>
                <div className="xb-header-menu-backdrop"></div>
              </div>
            </div>
            <div className="header-bar-mobile side-menu d-xl-none">
              <button
                className="xb-nav-mobile"
                onClick={() => setMobailState(!mobailActive)}
              >
                <i className="far fa-bars"></i>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Header;
